import React from 'react';

import SiteLayout from 'Config/SiteLayout';

export default class Unauthenticated extends React.Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render () {
        const Component = SiteLayout.site_layout_files.unauthenticated;
        
        return (<Component {...this.props} />);
    };
}
